"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridLayoutItem = exports.GridLayout = void 0;
var react_1 = __importDefault(require("react"));
var distillUtilityClasses_1 = __importDefault(require("../utility/distillUtilityClasses"));
exports.GridLayout = function (props) {
    var utilityClasses = distillUtilityClasses_1.default(props)[0];
    var classes = __spreadArrays([
        "l-grid",
        props.gap ? "+gap-" + props.gap : "",
        props.columns ? "+cols-" + props.columns : "",
        props.columnsSmall ? "+cols-" + props.columnsSmall + "@s" : "",
        props.columnsMedium ? "+cols-" + props.columnsMedium + "@m" : "",
        props.columnsLarge ? "+cols-" + props.columnsLarge + "@l" : ""
    ], utilityClasses);
    return react_1.default.createElement("div", { className: classes.join(" ") }, props.children);
};
exports.GridLayoutItem = function (props) {
    var utilityClasses = distillUtilityClasses_1.default(props)[0];
    var classes = __spreadArrays([
        "l-grid__item",
        props.span ? "+span-" + props.span : "",
        props.inset ? "+inset-" + props.inset : "",
        props.fraction ? "+fr-" + props.fraction : "",
        props.insetFraction ? "+insetfr-" + props.insetFraction : ""
    ], utilityClasses);
    return react_1.default.createElement("div", { className: classes.join(" ") }, props.children);
};
exports.GridLayout.Item = exports.GridLayoutItem;
//# sourceMappingURL=GridLayout.js.map